<template>
  <div class="panel-body">
    ExpenseDetails
  </div>
</template>

<script>

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/ExpenseDetails.vue